<template>
  <dd-modal
    v-model:visible="visible"
    title="Track Time in Harvest"
    desktop-sizing="small"
    class="harvest-modal"
  >
    <iframe :src="harvestSrc" class="harvest-iframe" />
  </dd-modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'HarvestModal',

  props: {
    /**
     * Sync prop to show and hide modal
     */
    showModal: {
      type: Boolean,
      default: false,
    },
    permaLink: {
      type: String,
      required: true,
    },
    entityName: {
      type: String,
      required: true,
    },
    itemTitle: {
      type: String,
      required: true,
    },
    itemId: {
      type: Number,
      required: true,
    },
    refNumber: {
      type: Number,
      required: true,
    },
  },

  emits: ['update:showModal'],

  computed: {
    visible: {
      get(): boolean {
        return this.showModal
      },
      set(newValue: boolean) {
        this.$emit('update:showModal', newValue)
      },
    },
    harvestSrc(): string {
      return (
        'https://platform.harvestapp.com/platform/timer?app_name=DoneDone&closable=false&chromeless=true' +
        '&external_item_id=' +
        this.itemId +
        '&external_item_name=' +
        encodeURIComponent('#' + this.refNumber + ': ' + this.itemTitle) +
        '&default_project_name=' +
        encodeURIComponent(this.entityName) +
        '&permalink=' +
        encodeURIComponent(this.permaLink)
      )
    },
  },
})
</script>

<style lang="scss">
.harvest-modal {
  .harvest-iframe {
    width: 100%;
    margin-top: 20px;
    height: 400px;
    overflow: hidden;
    border: none;
  }

  .el-dialog__header {
    position: initial;
    flex-flow: none;
    flex-grow: 0;
  }

  .el-dialog__body {
    height: 100%;
  }

  .el-dialog__body .dd-modal__content {
    padding-top: 0 !important;
  }
}
</style>
